import NavbarView from '../../views/navbarView/NavbarView';
import MethodsView from './views/MethodsView';
import { MethodsDataProvider } from './context/MethodsContext';
import LogoFooter from '../../components/Footer/LogoFooter/LogoFooter';
import { StyledMain } from '../../components/Footer/LogoFooter/styling';
import useCsideScript from '../../hooks/useCsideScript';

export function Methods() {
    useCsideScript();

    return (
        <>
            <NavbarView />
            <StyledMain>
                <MethodsDataProvider>
                    <MethodsView />
                </MethodsDataProvider>
            </StyledMain>
            <LogoFooter />
        </>
    );
}
